import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { orderByValidationType } from "@tfg/types/schemas/organization/schemas"

import { SortBuilder } from "~/components/SortBuilder"

interface Props {
  sort: Partial<orderByValidationType>
  setSort: Dispatch<SetStateAction<Partial<orderByValidationType>>>
}

export const SupplierSort = ({ sort, setSort }: Props) => {
  const { t } = useTranslation("suppliers")
  return (
    <SortBuilder<orderByValidationType>
      sorts={sort}
      setSorts={setSort}
      options={[
        {
          label: t("sort.name"),
          value: "name",
        },
        {
          label: t("sort.company"),
          value: "company",
        },
        {
          label: t("sort.pendingProductrequests"),
          value: "pendingProductrequests",
        },
        // {
        //   label: t("sort.pendingTransactionCertificaterequests"),
        //   value: "pendingTransactionCertificaterequests",
        // },
        // {
        //   label: t("sort.pendingScopeCertificaterequests"),
        //   value: "pendingScopeCertificaterequests",
        // },
        {
          label: t("sort.pendingProductionSiterequests"),
          value: "pendingProductionSiterequests",
        },
        {
          label: t("sort.completedProductrequests"),
          value: "completedProductrequests",
        },
        // {
        //   label: t("sort.completedTransactionCertificaterequests"),
        //   value: "completedTransactionCertificaterequests",
        // },
        // {
        //   label: t("sort.completedScopeCertificaterequests"),
        //   value: "completedScopeCertificaterequests",
        // },
        {
          label: t("sort.completedProductionSiterequests"),
          value: "completedProductionSiterequests",
        },
        {
          label: t("sort.email"),
          value: "email",
        },
        {
          label: t("sort.averageResponseTime"),
          value: "averageResponseTime",
        },
        {
          label: t("sort.lastConnectionDate"),
          value: "lastConnectionDate",
        },
        {
          label: t("sort.lastReminderDate"),
          value: "lastReminderDate",
        },
        // {
        //   label: t("sort.ratio"),
        //   value: "ratio",
        // },
      ]}
    />
  )
}
